var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHandPointer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "200px",
    width: "200px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-10 -10 406.576 406.576",
    xmlSpace: "preserve",
    fill: "#FFFFFF",
    stroke: "#000000",
    strokeWidth: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M323.54,173.105c-7.207,0-13.947,1.954-19.782,5.31c-3.462-18.395-19.595-32.312-39.007-32.312 c-7.874,0-15.186,2.316-21.361,6.274c-5.771-14.825-20.143-25.333-36.988-25.333c-7.398,0-14.286,2.051-20.219,5.57V39.715 C186.183,17.778,168.392,0,146.47,0c-21.941,0-39.714,17.778-39.714,39.715v179.202l-14.067-15.831 c-14.551-16.4-39.656-17.879-56.055-3.32c-16.403,14.573-17.891,39.675-3.32,56.075l86.635,97.547 c17.421,17.05,47.141,33.188,72.679,33.188h85.319c47.129,0,85.342-34.201,85.342-76.4l-0.035-97.351 C363.253,190.893,345.463,173.105,323.54,173.105z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandPointer);
export default __webpack_public_path__ + "static/media/hand-pointer.89ed5f48bfdfe75a5267eedc8daa2b38.svg";
export { ForwardRef as ReactComponent };